import { __decorate } from "tslib";
import { html, css, LitElement, nothing } from 'lit';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { property, query, state } from 'lit/decorators.js';
import { translate, use } from 'lit-translate';
import registerTranslateConfig from './helpers/registerTranslateConfig';
import './components/icon';
import './components/button';
registerTranslateConfig();
export class SgFeedback extends LitElement {
    constructor() {
        super(...arguments);
        this.projectId = 0;
        this.projectName = '';
        this.contentType = '';
        this.contentId = 0;
        this.contentUrl = '';
        this.contentTitle = '';
        this.contentText = '';
        this.endpoint = '';
        this.lang = 'es';
        this.ratingNote = '';
        this.feedbackText = '';
        this.ratingNps = '';
        this.ratingValue = '';
        this.idResponse = '';
        this.hp = false;
        this.showExtraFeedback = false;
        this.isMobile = window.innerWidth < 768;
        // @state() extraBoxPosition = 0;
        this.showSuccess = false;
        this.hideExtraFeedback = (e) => {
            const targetPath = e.composedPath();
            if ((!this.isMobile &&
                this.showExtraFeedback &&
                !targetPath.includes(this.feedbackWrapper)) ||
                (this.isMobile &&
                    this.showExtraFeedback &&
                    targetPath.includes(this.backgroundDarkElement))) {
                this.showExtraFeedback = false;
                this.showSuccess = false;
            }
        };
        this.postFeedback = (submitBtn = false) => {
            var _a;
            if (this.hp)
                return;
            const data = {
                project_id: this.projectId,
                project_name: this.projectName,
                content_title: this.contentTitle,
                content_url: this.contentUrl,
                content_type: this.contentType,
                content_id: this.contentId,
                rating_nps: this.ratingNps,
                rating_value: this.ratingValue,
                rating_note: this.feedbackText,
                rating_context: this.contentText,
                screen_width: window.innerWidth,
                user_agent: window.navigator.userAgent,
                device: window.innerWidth > 768 ? 'desktop' : 'mobile',
            };
            fetch(`${this.endpoint}/feedbacks/${(_a = this.idResponse) !== null && _a !== void 0 ? _a : ''}`, {
                body: JSON.stringify(data),
                method: this.idResponse ? 'PUT' : 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(data => {
                if (!this.idResponse) {
                    this.idResponse = data.data.last_inserted_id;
                }
                if (this.contentText && submitBtn) {
                    this.showSuccess = true;
                    setTimeout(() => {
                        this.showExtraFeedback = false;
                        this.showSuccess = false;
                    }, 2000);
                }
            })
                .catch(error => console.log(error));
        };
    }
    connectedCallback() {
        super.connectedCallback();
        use(this.lang);
        window.addEventListener('click', this.hideExtraFeedback);
        window.addEventListener('resize', this.setIsMobile);
    }
    disconnectedCallback() {
        window.removeEventListener('click', this.hideExtraFeedback);
        window.removeEventListener('resize', this.setIsMobile);
    }
    setIsMobile() {
        this.isMobile = window.innerWidth < 768;
    }
    setRating(rating) {
        if (rating === 100) {
            this.ratingNps = 'positive';
            this.ratingValue = '100';
        }
        else {
            this.ratingNps = 'negative';
            this.ratingValue = '0';
        }
    }
    handlebuttonClick(value, submitBtn = false) {
        this.setRating(value);
        this.postFeedback(submitBtn);
        this.showExtraFeedback = true;
    }
    handleTextareaChange(e) {
        const textarea = e.target;
        const value = textarea.value;
        this.feedbackText = value;
    }
    renderExtraFeedback() {
        return html `
      ${this.isMobile ? html `<div class="background-dark"></div>` : nothing}
      <div
        class="extra-feedback-container ${this.ratingValue === '100'
            ? 'extra-feedback-container_yes'
            : 'extra-feedback-container_no'}"
        style="
          ${this.isMobile ? `top: 50%;transform:translateY(-50%);` : ''}
          ${this.showSuccess
            ? 'display: flex;justify-content: center;align-items: center;'
            : ''}
          "
      >
        ${this.showSuccess
            ? html `<div class="text">${translate('feedback.success3')}</div>`
            : html `
              <div class="text">
                ${this.ratingValue === '100'
                ? html `${translate('feedback.success1')}`
                : html `${translate('feedback.success2')}`}
              </div>
              <div>
                <textarea
                  placeholder="${translate('feedback.textareaPlaceholder')}"
                  @input=${(e) => this.handleTextareaChange(e)}
                ></textarea>
                <button
                  @click=${() => this.handlebuttonClick(this.ratingValue === '100' ? 100 : 0, true)}
                >
                  ${translate('feedback.send')}
                </button>
              </div>
            `}
      </div>
    `;
    }
    render() {
        return html `
      ${this.isMobile && this.showExtraFeedback
            ? this.renderExtraFeedback()
            : nothing}
      <div class="feedback-wrapper">
        <span class="feedback-title">${translate('feedback.title')}</span>
        <sg-icon-button
          class="button-positive ${this.ratingValue === '100' ? 'active' : ''}"
          .arrow=${this.ratingValue === '100' && !this.isMobile}
          @button-click=${() => this.handlebuttonClick(100)}
          ><like-icon .active="${this.ratingValue === '100'}"
        /></sg-icon-button>
        <sg-icon-button
          .arrow=${this.ratingValue === '0' && !this.isMobile}
          class="button-negative ${this.ratingValue === '0' ? 'active' : ''}"
          @button-click=${() => this.handlebuttonClick(0)}
          ><like-icon
            .active="${this.ratingValue === '0'}"
            customStyles="transform: rotate(180deg)"
        /></sg-icon-button>
        <input style="display: none;" @input=${() => (this.hp = true)} />
        ${!this.isMobile && this.showExtraFeedback
            ? this.renderExtraFeedback()
            : nothing}
      </div>
    `;
    }
}
SgFeedback.styles = css `
    :host {
      --sg-feedback-font-family: 'Roboto', sans-serif;
      --sg-feedback-text-color: #505050;
      display: block;
      color: var(--sg-feedback-text-color);
      position: relative;
      font-size: 16px;
    }

    .feedback-wrapper {
      display: flex;
      align-items: center;
    }

    :host * {
      box-sizing: border-box;
      font-family: var(--sg-feedback-font-family);
    }

    .extra-feedback-container {
      position: absolute;
      width: 375px;
      min-height: 165px;
      bottom: 100%;
      background-color: white;
      border: 1px solid #b3b2b2;
      border-radius: 4px;
      padding: 10px;
      margin-bottom: 10px;
      z-index: 2;
      filter: drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.15))
        drop-shadow(0px 8px 20px rgba(0, 0, 0, 0.25));
    }
    @media (max-width: 768px) {
      .extra-feedback-container {
        width: 100%;
        left: 0;
        position: fixed;
        top: 50%;
        display: inline-table;
        left: 5px;
        right: 5px;
        width: calc(100% - 10px);
      }
    }

    .extra-feedback-container_no::after {
      right: 138px;
    }

    .extra-feedback-container .text {
      margin-bottom: 10px;
      font-size: 14px;
    }

    .extra-feedback-container textarea {
      width: 100%;
      border: 1px solid #b3b2b2;
      border-radius: 4px;
      padding: 10px;
      font-size: 16px;
      margin-bottom: 10px;
      min-height: 100px;
      padding-bottom: 40px;
      background-color: #fafafa;
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1) inset;
      resize: none;
    }

    .extra-feedback-container button {
      position: absolute;
      border: 1px solid #d5d5d5;
      border-radius: 4px;
      background-color: #e2e2e2;
      padding: 5px 10px;
      right: 15px;
      bottom: 30px;
      font-size: 14px;
      color: #7d8591;
      font-weight: bold;
      -webkit-font-smoothing: antialiased;
      transition: all 0.2s ease-in-out;
    }

    .extra-feedback-container button:hover {
      background-color: #fff;
    }

    .background-dark {
      background-color: rgba(0, 0, 0, 0.35);
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1;
    }

    .feedback-title {
      margin-right: 10px;
      font-size: 14px;
      color: #505050;
    }
    @media (min-width: 768px) {
      .feedback-title {
        margin-right: 5px;
        font-size: 12px;
      }
    }

    .button-positive {
      margin-right: 5px;
    }
  `;
__decorate([
    property({ type: Number })
], SgFeedback.prototype, "projectId", void 0);
__decorate([
    property({ type: String })
], SgFeedback.prototype, "projectName", void 0);
__decorate([
    property({ type: String })
], SgFeedback.prototype, "contentType", void 0);
__decorate([
    property({ type: Number })
], SgFeedback.prototype, "contentId", void 0);
__decorate([
    property({ type: String })
], SgFeedback.prototype, "contentUrl", void 0);
__decorate([
    property({ type: String })
], SgFeedback.prototype, "contentTitle", void 0);
__decorate([
    property({ type: String })
], SgFeedback.prototype, "contentText", void 0);
__decorate([
    property({ type: String })
], SgFeedback.prototype, "endpoint", void 0);
__decorate([
    property({ type: String })
], SgFeedback.prototype, "lang", void 0);
__decorate([
    state()
], SgFeedback.prototype, "ratingNote", void 0);
__decorate([
    state()
], SgFeedback.prototype, "feedbackText", void 0);
__decorate([
    state()
], SgFeedback.prototype, "ratingNps", void 0);
__decorate([
    state()
], SgFeedback.prototype, "ratingValue", void 0);
__decorate([
    state()
], SgFeedback.prototype, "idResponse", void 0);
__decorate([
    state()
], SgFeedback.prototype, "hp", void 0);
__decorate([
    state()
], SgFeedback.prototype, "showExtraFeedback", void 0);
__decorate([
    state()
], SgFeedback.prototype, "isMobile", void 0);
__decorate([
    state()
], SgFeedback.prototype, "showSuccess", void 0);
__decorate([
    query('.feedback-wrapper')
], SgFeedback.prototype, "feedbackWrapper", void 0);
__decorate([
    query('.background-dark')
], SgFeedback.prototype, "backgroundDarkElement", void 0);
__decorate([
    query('.button-positive')
], SgFeedback.prototype, "btnPositive", void 0);
__decorate([
    query('.button-negative')
], SgFeedback.prototype, "btnNegative", void 0);
__decorate([
    query('sg-icon-button.active')
], SgFeedback.prototype, "activeBtn", void 0);
__decorate([
    query('.extra-feedback-container')
], SgFeedback.prototype, "extraFeedbackElement", void 0);
//# sourceMappingURL=SgFeedback.js.map